import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { toast } from 'material-react-toastify';
import {
  Box,
  Button,
  Divider,
  IconButton,
  Paper,
  TextField,
  Typography,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { getEmptyNewUser } from '../../interfaces/User/NewUser';
import { createUser } from '../../api/User';
import { sharedStyles } from '../../utils/Style';
import { Waiting } from '../../components/Waiting/Waiting';

export const CreateUserPage = () => {
  const navigate = useNavigate();

  const [user, setUser] = useState(getEmptyNewUser());
  const [loading, setLoading] = useState(false);

  const handleSave = () => {
    setLoading(true);
    createUser(user)
      .then((createdUser) => {
        toast.success('Kullanıcı başarıyla oluşturuldu');
        navigate(`/users/users/${createdUser.id}`);
      })
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  };

  const goBack = () => navigate('/users/users');

  return (
    <Box sx={{ ...sharedStyles.pageBody }}>
      <Waiting open={loading} />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          flexWrap: 'wrap',
          mb: 3,
          gap: 1.5,
        }}
      >
        <IconButton onClick={goBack} sx={{ ...sharedStyles.backIcon }}>
          <ArrowBackIcon />
        </IconButton>
        <Typography variant='h5'>Yeni Kullanıcı</Typography>
      </Box>

      <Paper
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: 'fit-content',
          width: '100%',
          maxWidth: 500,
          p: 3,
          gap: 1.5,
          boxSizing: 'border-box',
        }}
      >
        <Typography
          sx={{
            ...sharedStyles.h5,
            fontWeight: 'bold',
          }}
        >
          Kullanıcı Bilgileri
        </Typography>
        <Divider />

        <TextField
          label='İsim'
          variant='outlined'
          size='small'
          value={user.firstName}
          onChange={(e) => setUser({ ...user, firstName: e.target.value })}
          fullWidth
        />

        <TextField
          label='Soysim'
          variant='outlined'
          size='small'
          value={user.lastName}
          onChange={(e) => setUser({ ...user, lastName: e.target.value })}
          fullWidth
        />

        <TextField
          label='E-Posta Adresi'
          variant='outlined'
          size='small'
          value={user.email}
          onChange={(e) => setUser({ ...user, email: e.target.value })}
          fullWidth
        />

        <TextField
          label='Telefon Numarası'
          variant='outlined'
          size='small'
          value={user.phone}
          onChange={(e) => setUser({ ...user, phone: e.target.value })}
          fullWidth
        />

        <Button
          variant='contained'
          onClick={handleSave}
          sx={{ ...sharedStyles.buttonText }}
        >
          Kaydet
        </Button>
      </Paper>
    </Box>
  );
};
